
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { recordUsage, sortCategoriesByUsage } from "@/lib/services/usageFrequencyService";

type ProductCategory = 'all' | 'ostomy' | 'medicine' | 'other';

interface ProductCategoryFilterProps {
  selectedCategory: ProductCategory;
  onCategoryChange: (category: ProductCategory) => void;
}

const ProductCategoryFilter = ({ 
  selectedCategory, 
  onCategoryChange 
}: ProductCategoryFilterProps) => {
  const categories = ['ostomy', 'medicine', 'other'];
  const sortedCategories = sortCategoriesByUsage(categories);

  const handleCategoryChange = (value: ProductCategory) => {
    if (value !== 'all') {
      recordUsage('category', value);
    }
    onCategoryChange(value);
  };

  return (
    <div className="w-full max-w-xs">
      <Select 
        value={selectedCategory} 
        onValueChange={handleCategoryChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Filter by category" />
        </SelectTrigger>
        <SelectContent className="bg-background border border-border shadow-lg z-50">
          <SelectItem value="all">All Categories</SelectItem>
          {sortedCategories.map(category => (
            <SelectItem key={category} value={category}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ProductCategoryFilter;
